/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseType } from '../../models/course-type';
import { CourseTypeCriteria } from '../../models/course-type-criteria';

export interface ApiMasterCourseTypeGetByCriteriaPost$Params {
      body?: CourseTypeCriteria
}

export function apiMasterCourseTypeGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterCourseTypeGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseType>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseTypeGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CourseType>>;
    })
  );
}

apiMasterCourseTypeGetByCriteriaPost.PATH = '/api/Master/CourseType/GetByCriteria';
